import { useAxiosCreate } from '@/backend/utils.js'
import authHeader from '@/backend/auth/auth-header'


const api = useAxiosCreate('api')

export async function calculateCommercialCalculator(payload) {
  const response = await api.post('commercial-calculator/calculate', payload, {
    headers: authHeader(),
  })
  return response.data
}

export async function getSubsidyClients() {
  const response = await api.get('commercial-calculator/subsidy-clients', {
    headers: authHeader(),
  })
  return response.data
}

export async function getSubsidyPaymentTerms() {
  const response = await api.get('commercial-calculator/subsidy-payment-terms', {
    headers: authHeader(),
  })
  return response.data
}

export async function getCommercialCalculatorConfig() {
  const response = await api.get('commercial-calculator/config', {
    headers: authHeader(),
  })
  return response.data
}

export async function getCommercialCalculatorRuntimeConfig() {
  const response = await api.get('commercial-calculator/runtime-config', {
    headers: authHeader(),
  })
  return response.data
}

export async function getCommercialCalculatorConfigHistory() {
  const response = await api.get('commercial-calculator/config/history', {
    headers: authHeader(),
  })
  return response.data
}

export async function getCommercialCalculatorConfigVersion(version) {
  const response = await api.get(`commercial-calculator/config/versions/${encodeURIComponent(version)}`, {
    headers: authHeader(),
  })
  return response.data
}

export async function createCommercialCalculatorConfigDraft(payload = {}) {
  const response = await api.post('commercial-calculator/config/drafts', payload, {
    headers: authHeader(),
  })
  return response.data
}

export async function getCommercialCalculatorConfigDrafts() {
  const response = await api.get('commercial-calculator/config/drafts', {
    headers: authHeader(),
  })
  return response.data
}

export async function getCommercialCalculatorConfigDraft(draftId) {
  const response = await api.get(`commercial-calculator/config/drafts/${encodeURIComponent(draftId)}`, {
    headers: authHeader(),
  })
  return response.data
}

export async function deleteCommercialCalculatorConfigDraft(draftId) {
  const response = await api.delete(`commercial-calculator/config/drafts/${encodeURIComponent(draftId)}`, {
    headers: authHeader(),
  })
  return response.data
}

export async function updateCommercialCalculatorConfigDraft(draftId, payload) {
  const response = await api.put(`commercial-calculator/config/drafts/${encodeURIComponent(draftId)}`, payload, {
    headers: authHeader(),
  })
  return response.data
}

export async function validateCommercialCalculatorConfigDraft(draftId) {
  const response = await api.post(`commercial-calculator/config/drafts/${encodeURIComponent(draftId)}/validate`, {}, {
    headers: authHeader(),
  })
  return response.data
}

export async function calculateCommercialCalculatorConfigDraft(draftId, payload) {
  const response = await api.post(`commercial-calculator/config/drafts/${encodeURIComponent(draftId)}/calculate`, payload, {
    headers: authHeader(),
  })
  return response.data
}

export async function previewCommercialCalculatorConfigDraft(draftId) {
  const response = await api.post(`commercial-calculator/config/drafts/${encodeURIComponent(draftId)}/preview`, {}, {
    headers: authHeader(),
  })
  return response.data
}

export async function publishCommercialCalculatorConfigDraft(draftId, payload) {
  const response = await api.post(`commercial-calculator/config/drafts/${encodeURIComponent(draftId)}/publish`, payload, {
    headers: authHeader(),
  })
  return response.data
}

export async function rollbackCommercialCalculatorConfigVersion(version, payload) {
  const response = await api.post(`commercial-calculator/config/versions/${encodeURIComponent(version)}/rollback`, payload, {
    headers: authHeader(),
  })
  return response.data
}

export async function calculateCommercialCalculatorDeal(payload) {
  const response = await api.post('commercial-calculator/calculate/deal', payload, {
    headers: authHeader(),
  })
  return response.data
}
